import React, { useEffect } from "react";

const AppCenteredInfo = ({
  message,
  onClickClose,
  onSubmit,
  title,
  buttonText,
  buttonIcon,
  bodyClass,
  titleClass,
  headerTitle
}) => {
  const onCloseCenteredInfo = () => {
    onClickClose(true);
  };
  useEffect(() => {
    const popup = document.getElementById("popup-bg-centered");

    if (popup) {
      popup.addEventListener("click", () => onCloseCenteredInfo(), false);
    }
  }, []);
  return (
    <div>
      <div className="modal-bg-centered" id="popup-bg-centered" />
      <div className="modal-centered">
        {/* Header */}
        <div className="head-general with-back">
          <a href="javascript: void(0)" />
          <h4 className="info-title">{headerTitle || ""}</h4>
          <a
            href="javascript: void(0)"
            onClick={() => onClickClose(true)}
            className="close"
          >
            <icon className="icon icon-close" />
          </a>
        </div>
        {/* Header */}
        <div className={`${titleClass} modal-body sticky-buttons`}>
          <h4>{title || ""}</h4>
          <div
            className={`${bodyClass} promo-error white-bg`}
            style={{ whiteSpace: "pre-wrap" }}
            dangerouslySetInnerHTML={{ __html: message }}
          />
          <div className="use-buttons">
            <button
              className="btn btn-blue"
              id="rewards-button"
              onClick={() => onSubmit(false)}
            >
              {buttonText}
              {buttonIcon && <icon className={`icon ${buttonIcon}`} />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppCenteredInfo;
